export default __webpack_public_path__ + "static/media/GasIcon.7321c3d9.svg";